import mod from "-!./ABackdrop.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./ABackdrop.js?vue&type=script&lang=js&external"